define([
	'jquery',
	'pubsub'
	], function($,pubsub) {

	// FOOTER EMAIL SUBSCRIPTION ADD
	$.pubsub('subscribe', 'vfdp.aem.footer.emailsignup', function(msg, pubSubObj) {
		if (pubSubObj.result && pubSubObj.response.sfAccountId) {
			try {
				window.dataLayer.push({
					'event': 'sfUserIdentification',
					'sfUserIdentificationSource': 'Newsletter Subscription: Footer',
					'sfUserId': pubSubObj.response.sfAccountId
				});
			} catch (err) {
				console.error('Failed push to dataLayer',err);
			}
		}
	});
});
